module.exports = __webpack_public_path__ + "img/组 134.43fe46fc.png";